const theme = {
    light: {
        Magenta: "#E6017E",
        Lao: "#A0A0A0",
        Cyan: "#00D9FF",
        Coco: "#C0C0C0",
        ONED: "#1D1D1D",
        Ey: "#E1E1E1",
        Ed: "#f6f3f3",
        Audi: "#A4A4A4",
        THREEB: "#3B3B3B",
        Checo: "#FAFAFA",
        Black: "#000000",
        White: "#FFFFFF",
        Red: "#D51313",
        Orange: "#FF962E",
        Blue: "#1654FF",
        SEVENB: "#7B7B7B",
        Lime: "#92CD62",
        Yellow: "#FFD700",
        Verde: "#31BD00",
        Alfalfa: "#FAFAFA",
        Brown: "#9D4E00",
        Teal: "#439E9E",
        Guardsman:"#b80000",
        Mint: "#8bff7c",
        LRed: "#ffc6c6",
        LGreen: "#D4FFC5",
        SGreen: "#207c00",
    },

    dark: {
        Magenta: "#f067b2",
        Cyan: "#66E5FF",
        Red: "#FF5252",
        Orange: "#f5a14d",
        Blue: "#6690FF",
        Lime: "#a0e664",
        Yellow: "#cdc867",
        Verde: "#58D63D",
        Teal: "#64BDBB",
        Guardsman: "#E63946",
        Mint: "#A7FF9D",
        Brown: "#C68E5A",
        White: "#121212",
        Black: "#FFFFFF",
        Checo: "#1E1E1E",
        Alfalfa: "#2C2C2C",
        ONED: "#F5F5F5",
        THREEB: "#E0E0E0",
        SEVENB: "#B0B0B0",
        Audi: "#8A8A8A",
        Lao: "#b0b0b0",
        Coco: "#707070",
        Ey: "#333333",
        Ed: "#0e0e0e",
        LRed: "#5C2B2B",
        LGreen: "#D4FFC5",
        SGreen: "#207c00",
        FOURFOUR: "#444444",
        LMagenta: "#FF8CC8",
    }
}

export default theme;